import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import axios from '@/libs/axios'
import orderModel from './orderModel'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

const dashboardEndpointV2 = jwtDefaultConfig.DASHBOARD_ENDPOINT.replace('v1', 'v2')
const {
  fetchAll,
  fetchOne,
  create,
  update,
  deleteMany,
} = useModelStoreModule(orderModel, false, null, dashboardEndpointV2)

const updateOrderStatus = (_, { orderId, status }) => new Promise((resolve, reject) => {
  axios
    .put(`${jwtDefaultConfig.BACKEND_HOST}/${dashboardEndpointV2}/${orderModel.name}/${orderId}`, { status })
    .then(response => {
      if (response && (response.status === 200)) {
        return resolve(orderModel.fromArray(response.data.data))
      }
      return reject(new Error('Operation Failed!'))
    })
    .catch(error => reject(error))
})

const updatePaymentStatus = (_, { orderId, status }) => new Promise((resolve, reject) => {
  axios
    .put(`${jwtDefaultConfig.BACKEND_HOST}/${dashboardEndpointV2}/${orderModel.name}/${orderId}`, { is_paid: status })
    .then(response => {
      if (response && (response.status === 200)) {
        return resolve(orderModel.fromArray(response.data.data))
      }
      return reject(new Error('Operation Failed!'))
    })
    .catch(error => reject(error))
})

const options = (_, queryParams) => new Promise((resolve, reject) => {
  axios
    .get(`${jwtDefaultConfig.BACKEND_HOST}/${dashboardEndpointV2}/${orderModel.name}/options`, { params: queryParams })
    .then(response => resolve(response))
    .catch(error => reject(error))
})

export default {
  name: 'orders',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll,
    fetchOne,
    create,
    update,
    updateOrderStatus,
    updatePaymentStatus,
    deleteMany,

    options,
  },
}
